export type BookkeepingPlatform = (typeof allBookkeepingPlatforms)[number]

/**
 * The bookkeeping platforms a client can pick from when granting access.
 * The order here is the order they are displayed in.
 */
export const allBookkeepingPlatforms = ['Xero', 'QuickBooks', 'Other'] as const
